"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pickupPointsSearchConfigurationContext = exports.PickupPointsSearchConfigurationProvider = void 0;
var _react = require("react");
var _models = require("../models");
const pickupPointsSearchConfigurationContext = exports.pickupPointsSearchConfigurationContext = /*#__PURE__*/(0, _react.createContext)(_models.DEFAULT_PICKUP_SEARCH_CONFIG);
const PickupPointsSearchConfigurationProvider = exports.PickupPointsSearchConfigurationProvider = pickupPointsSearchConfigurationContext.Provider;